import { render, staticRenderFns } from "./tag-export-modal.vue?vue&type=template&id=8dbbd118&scoped=true&"
import script from "./tag-export-modal.vue?vue&type=script&lang=js&"
export * from "./tag-export-modal.vue?vue&type=script&lang=js&"
import style0 from "./tag-export-modal.vue?vue&type=style&index=0&id=8dbbd118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbbd118",
  null
  
)

export default component.exports